import { INganHangActionTypes } from "../../action-types/ngan-hang/INganHangActions";
import { INganHangReducer } from "../../reducer-model/category/INganHangReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const initialState = {
  nganHangs: [],
  status: eReducerStatusBase.is_not_initialization,
  statusBank: eReducerStatusBase.is_not_initialization,
  traSoatQR: [],
  banks: [],
} as INganHangReducer;

export const nganHangReducer = (
  state: INganHangReducer = initialState,
  action: INganHangActionTypes
): INganHangReducer => {
  switch (action.type) {
    case "NGAN_HANG_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "NGAN_HANG_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        nganHangs: action.payload,
      };
    case "NGAN_HANG_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "NGAN_HANG_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "NGAN_HANG_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false,
      };
    case "NGAN_HANG_SAVE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "NGAN_HANG_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "NGAN_HANG_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "NGAN_HANG_DELETE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "NGAN_HANG_SHOW_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: true,
        nganHangEditing: action.payload,
      };
    case "NGAN_HANG_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false,
        nganHangEditing: undefined,
      };
    case "NGAN_HANG_GENQR_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "NGAN_HANG_GENQR_SUCCESS":
      return {
        ...state,
        qrResponse: action.payload,
        status: eReducerStatusBase.is_completed,
      };
    case "NGAN_HANG_GENQR_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        qrResponse: undefined,
      };
    case "NGAN_HANG_REMOVE_QR":
      return {
        ...state,
        qrResponse: undefined,
      };
    case "NGAN_HANG_TRA_SOAT_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "NGAN_HANG_TRA_SOAT_SUCCESS":
      const exist = state.traSoatQR.some(
        (g) =>
          g.id_bien_lai === action.payload.id_bien_lai &&
          g.id_encode === action.payload.id_encode &&
          g.code_bank === action.payload.code_bank
      );
      return {
        ...state,
        traSoatQR: exist
          ? [...state.traSoatQR]
          : [...state.traSoatQR, action.payload],
        status: eReducerStatusBase.is_completed,
      };
    case "NGAN_HANG_TRA_SOAT_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "NGAN_HANG_LOAD_BANK_START":
      return {
        ...state,
        statusBank: eReducerStatusBase.is_loading,
      };
    case "NGAN_HANG_LOAD_BANK_SUCCESS":
      return {
        ...state,
        statusBank: eReducerStatusBase.is_completed,
        banks: action.payload,
      };
    case "NGAN_HANG_LOAD_BANK_ERRR":
      return {
        ...state,
        statusBank: eReducerStatusBase.is_completed,
      };
    default:
      return state;
  }
};
